import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";
import { ArrowLeft } from "lucide-react";

export default function AdminLoginPage() {
    const { login } = useAuth();
    const nav = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const res = await login(email, password);
        setLoading(false);
        if (res.ok) {
            toast.success("Welcome back, Coach.");
            nav("/admin");
        } else {
            toast.error(res.error);
        }
    };

    return (
        <div data-testid="admin-login-page" className="min-h-screen bg-black flex items-center justify-center px-6 topo-bg">
            <div className="absolute top-8 left-8">
                <Link to="/" className="inline-flex items-center gap-2 text-xs uppercase tracking-widest text-white/60 hover:text-volt">
                    <ArrowLeft size={14} /> Back to site
                </Link>
            </div>
            <form onSubmit={submit} className="w-full max-w-md bg-zinc-900 border border-white/10 p-10">
                <div className="flex items-center gap-2 mb-6">
                    <span className="w-2.5 h-2.5 bg-volt inline-block" />
                    <span className="font-heading text-xl tracking-wider">Elite Player Academy</span>
                </div>
                <h1 className="text-4xl font-heading uppercase">Admin Access</h1>
                <p className="mt-2 text-sm text-white/50">Sign in to manage content and applications.</p>

                <div className="mt-8 space-y-5">
                    <div>
                        <Label className="text-xs uppercase tracking-widest text-white/60">Email</Label>
                        <Input
                            data-testid="admin-login-email"
                            type="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="mt-2 bg-black border-white/10 focus:border-volt focus:ring-volt rounded-none"
                        />
                    </div>
                    <div>
                        <Label className="text-xs uppercase tracking-widest text-white/60">Password</Label>
                        <Input
                            data-testid="admin-login-password"
                            type="password"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="mt-2 bg-black border-white/10 focus:border-volt focus:ring-volt rounded-none"
                        />
                    </div>
                    <button
                        data-testid="admin-login-submit"
                        disabled={loading}
                        className="btn-volt w-full py-3 disabled:opacity-60"
                    >
                        {loading ? "Signing in…" : "Sign In"}
                    </button>
                </div>
            </form>
        </div>
    );
}
